import React, { Component } from "react";

import '../styles/myfooter.css';

class MyFooter extends Component {

    render() {
        return ( <footer>This is the footer of the page</footer> )
    }

}

export default MyFooter;